// extracted by mini-css-extract-plugin
export default {"BannerWrapper":"Banner_BannerWrapper__q3dz5","BannerView":"Banner_BannerView__ngXxD","con":"Banner_con__lSd5L","bottom":"Banner_bottom__rDfb8"};